import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import CookieConsent from './CookieConsent';
import { CrisisDetector } from './CrisisDetection';

const MarketingLayout: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Header />
      <Outlet />
      <CookieConsent />
      <CrisisDetector />
    </Box>
  );
};

export default MarketingLayout;
